var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-modal"},[_c('div',{staticClass:"secondary-menu-header"},[_c('i',{staticClass:"back",on:{"click":function($event){return _vm.closeModal()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"payment-modal-body"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"logo-tagline"},[_vm._v("\n      BUDDY"),_c('span',[_vm._v("PRO")])])
}]

export { render, staticRenderFns }